import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue3 from 'bootstrap-vue-3'
import VueAxios from 'vue-axios'
import axios from 'axios'

import "./assets/css/bootstrap.css";
import "./assets/css/dark.css";

axios.defaults.baseURL = window.API_URL;

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next('/login');
  } else {
    next();
  }
});

createApp(App).use(VueAxios, axios).use(BootstrapVue3).use(store).use(router).mount('#app')
